var _style, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPosition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E09F0D;}\n\t.st1{fill:#243193;}\n\t.st2{fill:#BCC0D8;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 193.3,
    r: 42
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,304.5c-61.3,0-111.1-49.8-111.1-111.1S194.7,82.2,256,82.2S367.1,132,367.1,193.3S317.3,304.5,256,304.5z  M256,110.9c-45.4,0-82.4,37-82.4,82.4s37,82.4,82.4,82.4s82.4-37,82.4-82.4S301.4,110.9,256,110.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,0C149.4,0,62.6,86.7,62.6,193.4c0,72.1,39.6,135,98.3,168.3l82.7,143.2c2.6,4.4,7.3,7.2,12.4,7.2 s9.9-2.7,12.4-7.2l84-145.5c4-6.9,1.6-15.6-5.3-19.6s-15.6-1.6-19.6,5.3L256,469l-51.5-89.2c16.4,4.5,33.7,7,51.5,7 c7.9,0,14.3-6.4,14.3-14.3S263.9,358,256,358c-90.8,0-164.7-73.9-164.7-164.7S165.2,28.7,256,28.7s164.7,73.9,164.7,164.7 c0,40.9-15.1,80.1-42.5,110.4c-5.3,5.9-4.9,15,1,20.3s15,4.9,20.3-1c32.2-35.6,49.9-81.6,49.9-129.7C449.4,86.7,362.6,0,256,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.604a2e3fdf2987d16c8564f0dd76455b.svg";
export { ForwardRef as ReactComponent };